import script from "./ACarregamentoCalendario.vue?vue&type=script&setup=true&lang=ts"
export * from "./ACarregamentoCalendario.vue?vue&type=script&setup=true&lang=ts"

import "./ACarregamentoCalendario.vue?vue&type=style&index=0&id=66df0ab4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66df0ab4"]])

export default __exports__